const API_BASE='https://api.curacaosecure.com/v1';
const LEGACY_ADMIN='/internal-admin-v2';
const DEMO_TOKEN='map-reader-91ac833';
const chunks=['admin-panel.91ac.js','legacy-vpn.a22c.js','customer-export.888f.js'];
// PART1=BLUE